/**
 * Maximum number of sections to expand by default when rendering a report.
 * Reports with more sections than this will only expand the first N sections
 * to prevent the browser from freezing due to simultaneous heavy Markdown rendering.
 */
export const MAX_INITIALLY_EXPANDED_SECTIONS = 10;

/**
 * Returns the list of section IDs that should be initially expanded.
 * If the total number of sections exceeds MAX_INITIALLY_EXPANDED_SECTIONS,
 * only the first N sections are expanded to prevent browser performance issues.
 */
export function getInitialExpandedSections(allSectionIds: string[]): string[] {
  if (allSectionIds.length <= MAX_INITIALLY_EXPANDED_SECTIONS) {
    return allSectionIds;
  }
  return allSectionIds.slice(0, MAX_INITIALLY_EXPANDED_SECTIONS);
}
